// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bcLB","left":"styles_left__1K3HE"};